import { FaAngleDown } from "react-icons/fa6";

import { Container, Label, InputSelect, InputSelectItem } from "./styles";

function Select(props) {
  const { width, style, error, backgroundLabel, label, options, labelSelect = "Select" } = props;

  return (
    <Container width={width} style={style}>
      <Label error={error} backgroundLabel={backgroundLabel}>
        {label}
      </Label>

      <InputSelect error={error} {...props}>
        <InputSelectItem value="">{labelSelect}</InputSelectItem>
        {options?.map((option, i) => (
          <InputSelectItem key={i} value={option.id}>
            {option.name}
          </InputSelectItem>
        ))}
      </InputSelect>
      <FaAngleDown size={15} color="#b2b2b2" className="iconArrowDown" />
    </Container>
  );
}

export default Select;
